import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://gyhwurepgkfravoxgsup.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5aHd1cmVwZ2tmcmF2b3hnc3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUyMDUzNjQsImV4cCI6MjEwMDc4MTM2NH0.gsrKpZsntX1yZizmkc1Ai57K7LxmErkke0PQJ-dS-ng';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
